import React from "react";

import BatchDetail from "../../../common/BatchDetail";
import { unpauseColumns } from "../../../../constants/lineListColumns";
import { CLIENTS } from "../../../../constants/value";
import { __getUnpause } from "../../../../api/sim";

const COPY_KEYS = ["id", "batch_id", "iccid", "status", "last_updated"];

const UnpauseBatch = () => (
  <BatchDetail
    title="Unpause"
    apiGet={__getUnpause}
    client={CLIENTS.pwg}
    columnsFactory={(ctx) => unpauseColumns({ ...ctx, iccidHeaderName: "MDN" })}
    copyKeys={COPY_KEYS}
    exportAction="unpause"
    retryOperation="unpause"
    showTerminate
    getRowPath={(row) => `/pwg/unpause/${row.id}`}
  />
);

export default UnpauseBatch;
